module.exports = __webpack_public_path__ + "static/text3-a3ff59d23b78bbb805f25feb0a4cca7b.svg";